function DiagramViewer({
  diagram,
  system,
  hotspots,
  selectedPart,
  hoveredPart,
  setSelectedPart,
  setHoveredPart
}) {


  return (

    <div style={styles.diagramCard}>

      {/* HEADER */}
      <div style={styles.header}>
        <div style={styles.titleRow}>
        
          <span style={styles.title}>Parts Diagram</span>
        </div>

      <div style={styles.brandDivider}>
  <span style={styles.line}></span>
  <span style={styles.brandText}>ELEVEN</span>
  <span style={styles.line}></span>
</div>
      </div>

      {/* DIAGRAM AREA */}
      <div style={styles.viewer}>

        <img
  src={diagram}
  style={{
    ...styles.image,
    width:
      system === "Engine" || system === "Electrical"
        ? "65%"
        : "100%"
  }}
/>

      {(hotspots || []).map((spot) => (
          <div
            key={spot.id}
            style={{
              ...styles.hotspot,
              left:`${spot.x}%`,
              top:`${spot.y}%`
            }}
            onClick={()=>setSelectedPart(spot.id)}
            onMouseEnter={()=>setHoveredPart(spot.id)}
            onMouseLeave={()=>setHoveredPart(null)}
          >
            {spot.id}
          </div>



        ))}

      </div>


    </div>

  );
}

export default DiagramViewer;

const styles={

diagramCard:{
background:"rgba(248,251,255,0.92)",
borderRadius:28,
padding:"0 460px 40px 40px",
position:"relative",
width:"100%",
overflow:"hidden",

border:"1px solid rgba(255, 255, 255, 1)",

backdropFilter:"blur(10px)",
WebkitBackdropFilter:"blur(10px)",

boxShadow:
"0 0 0 2px rgba(255,255,255,0.7), \
0 10px 30px rgba(255,255,255,0.6), \
0 30px 80px rgba(0,0,0,0.05), \
0 12px 40px rgba(37,99,235,0.07)"
},
header:{
padding:"24px 0 0 0"
},

titleRow:{
display:"flex",
alignItems:"center",
gap:10,
fontSize:20,
fontWeight:600,
color:"#1D1D1F"
},

backArrow:{
fontSize:18,
color:"#6e6e73",
cursor:"pointer"
},

title:{
fontWeight:600
},

brandDivider:{
display:"flex",
alignItems:"center",
justifyContent:"center",
gap:14,
marginTop:18,
marginBottom:8
},

line:{
flex:1,
height:1,
background:"rgba(0,0,0,0.08)"
},

brandText:{
fontSize:12,
fontWeight:600,
letterSpacing:"0.45em",
color:"#8E8E93",
fontFamily:"Inter, -apple-system, BlinkMacSystemFont, system-ui"
},


divider:{
height:1,
background:"rgba(0,0,0,0.08)",
marginTop:18
},

viewer:{
position:"relative",
marginTop:30
},

image:{
width:"100%",
maxWidth:"850px",
objectFit:"contain",
display:"block",
margin:"0 auto",
pointerEvents:"none",
userSelect:"none"
},

hotspot:{
position:"absolute",
width:24,
height:24,
borderRadius:"50%",
background:"#fff",
border:"1px solid rgba(0,0,0,0.08)",
color:"#1D1D1F",
display:"flex",
alignItems:"center",
justifyContent:"center",
fontSize:12,
fontWeight:600,
transform:"translate(-50%, -50%)",
cursor:"pointer",
boxShadow:"0 4px 12px rgba(0,0,0,0.12)"
}

};